import React from 'react';
import './Neurocortex.css';
import NeurocortexGraphic from './NeurocortexGraphic';
import { useLanguage } from '../contexts/LanguageContext';

const Neurocortex = () => {
  const { t } = useLanguage();
  
  return (
    <section className="neurocortex" id="cozum">
      <div className="container">
        <h2 className="section-title">{t('neurocortex.title')}</h2>
        
        <NeurocortexGraphic />

        <div className="neurocortex-description">
          <p>
            {t('neurocortex.description1')}
          </p>
          <p>
            {t('neurocortex.description2')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Neurocortex; 